module.exports = __webpack_public_path__ + "static/michael-happy.3221630e.jpg";